<template>
  <section class="my-8 space-y-4">
    <h2
      v-if="block.title"
      class="text-xl font-bold text-[var(--arad-text)]"
    >
      {{ block.title }}
    </h2>
    <div
      v-if="pending"
      class="text-sm text-[var(--ui-text-muted)]"
    >
      در حال بارگذاری…
    </div>
    <div
      v-else-if="!doctors.length"
      class="rounded-2xl border border-dashed border-[var(--ui-border)] p-6 text-center text-sm text-[var(--ui-text-muted)]"
    >
      پزشکی برای این خدمت ثبت نشده است.
    </div>
    <div
      v-else
      class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3"
    >
      <div
        v-for="doctor in doctors"
        :key="doctor.id"
        class="flex items-center gap-3 rounded-2xl border border-[var(--ui-border)] bg-[var(--arad-surface)] p-4"
      >
        <img
          v-if="doctor.avatarUrl"
          :src="doctor.avatarUrl"
          alt=""
          class="size-14 rounded-xl object-cover"
        >
        <div
          v-else
          class="flex size-14 items-center justify-center rounded-xl bg-[var(--ui-bg-muted)]"
        >
          <UIcon
            name="i-lucide-user-round"
            class="size-6 text-[var(--ui-text-muted)]"
          />
        </div>
        <div class="min-w-0">
          <p class="font-semibold text-[var(--arad-text)]">
            {{ doctor.name }}
          </p>
          <p
            v-if="doctor.specialty"
            class="text-sm text-[var(--ui-text-muted)]"
          >
            {{ doctor.specialty }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { BlogServiceDoctorsBlock } from '~/types/blog'

const props = defineProps<{
  block: BlogServiceDoctorsBlock
  serviceSlug?: string
  preview?: boolean
}>()

const doctors = ref<Array<{ id: string; name: string; specialty: string | null; avatarUrl: string | null }>>([])
const pending = ref(false)

onMounted(async () => {
  if (props.preview || !props.serviceSlug) return
  pending.value = true
  try {
    const data = await $fetch<{ items: typeof doctors.value }>(
      `/api/services/${encodeURIComponent(props.serviceSlug)}/doctors`,
    )
    doctors.value = data.items ?? []
  }
  catch {
    doctors.value = []
  }
  finally {
    pending.value = false
  }
})
</script>
